/**
 * Wishlist functionality for automotive parts
 * Handles adding/removing products from wishlist using localStorage
 */
(function() {
  'use strict';

  // Initialize wishlist from localStorage
  let wishlist = JSON.parse(localStorage.getItem('wishlist') || '{}');
  
  // Update wishlist count display
  function updateWishlistCount() {
    const count = Object.keys(wishlist).length;
    const countElements = document.querySelectorAll('[data-wishlist-count]');
    countElements.forEach(el => {
      el.textContent = count;
      if (count === 0) {
        el.style.display = 'none';
      } else {
        el.style.display = 'flex';
      }
    });
  }
  
  // Update wishlist button state
  function updateWishlistButton(productId) {
    const buttons = document.querySelectorAll(`[data-product-id="${productId}"][data-wishlist-action="toggle"]`);
    const isInWishlist = !!wishlist[productId];
    
    buttons.forEach(button => {
      const icon = button.querySelector('.wishlist-icon path, .wishlist-icon svg path');
      const text = button.querySelector('.wishlist-text, span:not(.wishlist-icon)');
      
      if (isInWishlist) {
        button.classList.add('wishlist-btn--active');
        button.setAttribute('aria-label', 'Remove from wishlist');
        if (text && !text.classList.contains('wishlist-icon')) {
          const textSpan = text.querySelector('span') || text;
          if (textSpan.textContent && !textSpan.textContent.includes('REMOVE')) {
            textSpan.textContent = 'REMOVE FROM WISH LIST';
          }
        }
        if (icon) {
          icon.setAttribute('fill', 'currentColor');
        }
      } else {
        button.classList.remove('wishlist-btn--active');
        button.setAttribute('aria-label', 'Add to wishlist');
        if (text && !text.classList.contains('wishlist-icon')) {
          const textSpan = text.querySelector('span') || text;
          if (textSpan.textContent && !textSpan.textContent.includes('ADD')) {
            textSpan.textContent = 'ADD TO WISH LIST';
          }
        }
        if (icon) {
          icon.setAttribute('fill', 'none');
        }
      }
    });
  }
  
  // Get product data from DOM
  function getProductData(productId) {
    const productCard = document.querySelector(`[data-product-id="${productId}"]`)?.closest('.product-card');
    const productPage = document.querySelector('.product-page');
    
    // Try to get from product card first
    if (productCard) {
      const titleEl = productCard.querySelector('.product-card__title a, .product-card__title');
      const priceEl = productCard.querySelector('.price, .product-card__price .price');
      const imageEl = productCard.querySelector('.product-card__image--primary, .product-card__image');
      const linkEl = productCard.querySelector('.product-card__title a, a[href*="/products/"]');
      
      return {
        id: productId,
        title: titleEl?.textContent?.trim() || 'Product',
        price: priceEl?.textContent?.trim() || '0',
        image: imageEl?.src || imageEl?.getAttribute('srcset')?.split(',')[0]?.trim() || '',
        url: linkEl?.href || window.location.href
      };
    }
    
    // Try to get from product page
    if (productPage) {
      const titleEl = document.querySelector('h1.product-info__title, h1');
      const priceEl = document.querySelector('.price, .product-info__price, .price-display__value');
      const imageEl = document.querySelector('[data-gallery-main-image], .product-gallery img, img[alt*="product"]');
      const urlEl = document.querySelector('link[rel="canonical"]');
      
      return {
        id: productId,
        title: titleEl?.textContent?.trim() || 'Product',
        price: priceEl?.textContent?.trim() || '0',
        image: imageEl?.src || imageEl?.currentSrc || '',
        url: urlEl?.href || window.location.href
      };
    }
    
    // Fallback
    return {
      id: productId,
      title: 'Product',
      price: '0',
      image: '',
      url: window.location.href
    };
  }
  
  // Add/remove product from wishlist
  function toggleWishlist(productId, productData = null) {
    if (!productData) {
      productData = getProductData(productId);
    }
    
    console.log('toggleWishlist called with:', { productId, productData });
    
    if (wishlist[productId]) {
      console.log('Removing product from wishlist:', productId);
      delete wishlist[productId];
    } else {
      console.log('Adding product to wishlist:', productId, productData);
      wishlist[productId] = {
        id: productId,
        title: productData.title || 'Product',
        price: productData.price || '0',
        image: productData.image || '',
        url: productData.url || '#',
        addedAt: new Date().toISOString()
      };
    }
    
    const wishlistString = JSON.stringify(wishlist);
    console.log('Saving wishlist to localStorage:', wishlistString);
    localStorage.setItem('wishlist', wishlistString);
    
    // Verify it was saved
    const saved = localStorage.getItem('wishlist');
    console.log('Verified localStorage after save:', saved);
    
    updateWishlistCount();
    updateWishlistButton(productId);
    
    // Dispatch custom event
    const event = new CustomEvent('wishlistUpdated', { 
      detail: { productId, inWishlist: !!wishlist[productId] } 
    });
    document.dispatchEvent(event);
    
    // Show notification
    showWishlistNotification(wishlist[productId] ? 'added' : 'removed');
    
    return wishlist[productId];
  }
  
  // Show wishlist notification
  function showWishlistNotification(action) {
    // Remove existing notifications
    const existing = document.querySelector('.wishlist-notification');
    if (existing) {
      existing.remove();
    }
    
    const notification = document.createElement('div');
    notification.className = 'wishlist-notification';
    notification.innerHTML = `
      <div class="wishlist-notification__content">
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
          <path d="M10 18.35L8.55 17.03C3.4 12.36 0 9.28 0 5.5 0 2.42 2.42 0 5.5 0C7.24 0 8.91 0.81 10 2.09C11.09 0.81 12.76 0 14.5 0C17.58 0 20 2.42 20 5.5C20 9.28 16.6 12.36 11.45 17.04L10 18.35Z" fill="currentColor"/>
        </svg>
        <span>Product ${action} to wishlist!</span>
      </div>
    `;
    
    notification.style.cssText = `
      position: fixed;
      top: 20px;
      right: 20px;
      background-color: #D32F2F;
      color: white;
      padding: 1rem 1.5rem;
      border-radius: 6px;
      box-shadow: 0 4px 12px rgba(0,0,0,0.15);
      z-index: 10000;
      transform: translateX(100%);
      transition: transform 0.3s ease;
      display: flex;
      align-items: center;
      gap: 0.8rem;
      font-size: 1.4rem;
    `;
    
    document.body.appendChild(notification);
    
    // Animate in
    setTimeout(() => {
      notification.style.transform = 'translateX(0)';
    }, 100);
    
    // Remove after 3 seconds
    setTimeout(() => {
      notification.style.transform = 'translateX(100%)';
      setTimeout(() => {
        if (notification.parentNode) {
          notification.parentNode.removeChild(notification);
        }
      }, 300);
    }, 3000);
  }
  
  // Initialize wishlist buttons on page load
  function initializeWishlistButtons() {
    updateWishlistCount();
    
    // Update all wishlist buttons on the page
    document.querySelectorAll('[data-product-id][data-wishlist-action="toggle"]').forEach(btn => {
      const productId = btn.getAttribute('data-product-id');
      updateWishlistButton(productId);
    });
  }
  
  // Handle wishlist button clicks
  document.addEventListener('click', function(e) {
    const wishlistBtn = e.target.closest('[data-wishlist-action="toggle"]');
    if (wishlistBtn) {
      e.preventDefault();
      e.stopPropagation();
      const productId = wishlistBtn.getAttribute('data-product-id');
      
      console.log('Wishlist button clicked, productId:', productId);
      
      if (productId) {
        const productData = getProductData(productId);
        console.log('Product data retrieved:', productData);
        toggleWishlist(productId, productData);
      } else {
        console.error('No product ID found on wishlist button');
      }
    }
  });
  
  // Handle dropdown menu clicks
  document.addEventListener('click', function(e) {
    const dropdownItem = e.target.closest('[data-wishlist-action]');
    if (dropdownItem && dropdownItem.getAttribute('data-wishlist-action') !== 'toggle') {
      e.preventDefault();
      const action = dropdownItem.getAttribute('data-wishlist-action');
      const productId = dropdownItem.getAttribute('data-product-id');
      
      switch(action) {
        case 'add':
          if (productId) {
            const productData = getProductData(productId);
            toggleWishlist(productId, productData);
          }
          break;
        case 'view':
          // Redirect to wishlist page
          if (window.location.pathname.includes('/pages/wishlist')) {
            // Already on wishlist page, refresh
            window.location.reload();
          } else {
            window.location.href = '/pages/wishlist';
          }
          break;
      }
    }
  });
  
  // Handle quick view wishlist buttons
  document.addEventListener('click', function(e) {
    const quickViewBtn = e.target.closest('[data-wishlist-add]');
    if (quickViewBtn) {
      e.preventDefault();
      const productId = quickViewBtn.getAttribute('data-wishlist-add');
      
      if (productId) {
        // Get product data from quick view modal
        const quickViewContent = quickViewBtn.closest('.quick-view-content');
        const titleEl = quickViewContent?.querySelector('.quick-view__title');
        const priceEl = quickViewContent?.querySelector('.quick-view__price .price');
        const imageEl = quickViewContent?.querySelector('.quick-view__image');
        const productJson = document.querySelector('[data-product-json]');
        
        let productData = {
          id: productId,
          title: titleEl?.textContent?.trim() || 'Product',
          price: priceEl?.textContent?.trim() || '0',
          image: imageEl?.src || '',
          url: window.location.href
        };
        
        if (productJson) {
          try {
            const product = JSON.parse(productJson.textContent);
            productData.url = product.url || window.location.href;
            if (product.featured_image) {
              productData.image = product.featured_image;
            }
          } catch (e) {
            console.error('Error parsing product JSON:', e);
          }
        }
        
        toggleWishlist(productId, productData);
      }
    }
  });
  
  // Initialize on page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeWishlistButtons);
  } else {
    initializeWishlistButtons();
  }
  
  // Export for use in other scripts
  window.WishlistManager = {
    toggle: toggleWishlist,
    updateCount: updateWishlistCount,
    updateButton: updateWishlistButton,
    get: () => ({ ...wishlist }),
    getAll: () => Object.values(wishlist),
    remove: (productId) => {
      if (wishlist[productId]) {
        delete wishlist[productId];
        localStorage.setItem('wishlist', JSON.stringify(wishlist));
        updateWishlistCount();
        updateWishlistButton(productId);
        return true;
      }
      return false;
    }
  };
})();

